import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Input, InputRef, Row, Space } from "antd";
import { FilterConfirmProps } from "antd/lib/table/interface";
import { SearchOutlined } from "@ant-design/icons";

import styles from "./ColumnSearchField.module.less";

interface Props {
  selectedKeys: React.Key[];
  setSelectedKeys(selectedKeys: React.Key[]): void;
  handleSearch(confirm: (param?: FilterConfirmProps | undefined) => void): void;
  confirm(param?: FilterConfirmProps | undefined): void;
  clearFilters?(): void;
  handleReset(clearFilters: () => void): void;
}

const ColumnSearchField = React.forwardRef(
  (
    {
      selectedKeys,
      setSelectedKeys,
      handleSearch,
      confirm,
      clearFilters,
      handleReset,
    }: Props,
    searchInputRef: React.ForwardedRef<InputRef>
  ) => {
    const { t } = useTranslation();

    const onSearch = () => handleSearch(confirm);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
      setSelectedKeys(e.target.value ? [e.target.value] : []);

    const onClear = () => {
      if (clearFilters) {
        handleReset(clearFilters);
        onSearch();
      }
    };

    return (
      <Space className={styles.input_wrapper} direction="vertical">
        <Input
          ref={searchInputRef}
          placeholder={t("search")}
          value={selectedKeys[0]}
          onChange={onChange}
          onPressEnter={onSearch}
        />
        <Row gutter={10}>
          <Col span={12}>
            <Button
              type="primary"
              onClick={onSearch}
              icon={<SearchOutlined />}
              size="small"
              block
            >
              {t("search")}
            </Button>
          </Col>
          <Col span={12}>
            <Button onClick={onClear} size="small" block>
              {t("clear")}
            </Button>
          </Col>
        </Row>
      </Space>
    );
  }
);

export default ColumnSearchField;
